<template>
  <div class="report" style="padding-bottom:60px">
    <Button type="primary" :disabled="disabled" @click="addAll()" ghost>给筛查对象打标签</Button>

    <div style="margin-top:16px;position:relative;">
      <div class="allChoose">
        <CheckboxGroup v-model="animal" style="display:inline-block" @on-change="handleSelectAll()">
          <Checkbox label="current">全选当前页</Checkbox>
          <Checkbox label="all">全选所有页</Checkbox>
        </CheckboxGroup>

        <div
          style="display:inline-block;font-size: 14px;"
          v-if="animal[0] == 'all'"
        >已选({{total}}/{{total}})</div>
        <div
          style="display:inline-block;font-size: 14px;"
          v-else
        >已选({{patientIds.length}}/{{total}})</div>
      </div>
      <Table :columns="columns" :data="list" :loading="loading">
        <template slot-scope="{row,index}" slot="single">
          <img
            v-if="!row.single"
            style="width:15px"
            src="../../../images/icon_yda.png"
            @click="changeBox(row,index)"
            alt
          />
          <img
            v-else
            style="width:15px"
            src="../../../images/icon_wda.png"
            @click="changeBox(row,index)"
            alt
          />
        </template>
        <template slot-scope="{row}" slot="name">
          <template>{{row.name && row.name}}</template>
        </template>
        <template slot-scope="{row}" slot="gender">
          <template>{{row.gender == 0 ? '女' : '男' || '--'}}</template>
        </template>
        <template slot-scope="{row}" slot="age">
          <template>{{row.age || '--'}}</template>
        </template>
        <template slot-scope="{row}" slot="phone">
          <template>{{row.phone || '--'}}</template>
        </template>
        <template slot-scope="{row}" slot="create_time">
          <template>{{row.create_time && row.create_time.substring(0, 16)}}</template>
        </template>

        <template slot-scope="{row, index}" slot="action">
          <caring-button @click="patientDetail(row, index)">查看</caring-button>
        </template>
      </Table>
      <div style="margin-top:16px;text-align:right;">
        <Page
          :total="total"
          :current="current"
          :page-size="size"
          :page-size-opts="sizes"
          :show-total="true"
          :show-elevator="true"
          :show-sizer="true"
          @on-change="onCurrentChange"
          @on-page-size-change="onSizeChange"
        />
      </div>
    </div>
    <Modal v-model="modal1" :title="title" :ok-text="oktext" @on-cancel="cancel">
      <div class="modalBox">
        <span style="padding-left: 30px; padding-right: 10px;font-size: 15px;">{{titGroupd}}</span>
        <Input v-model.trim="value" v-if="adGroupd" placeholder="请输入标签名字" style="width: 300px" />
        <Select v-if="!adGroupd" v-model="tag_ids" multiple filterable style="width:300px">
          <Option v-for="item in tags" :value="item.id" :key="item.name">{{ item.name }}</Option>
        </Select>

        <span class="addspan" @click="addGroupd">+新增</span>
      </div>
      <div slot="footer">
        <Button type="info" @click="del">取消</Button>
        <Button type="info" @click="agree">{{oktext}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  addTag,
  getTag,
  classfiyTagPage,
  classfiyTagTotal,
} from '../../../api/tag'
import { filtrate, confirmedFiltrate } from '../../../api/analysis'
import route from '../../../route/config'
export default {
  name: 'customQuery',
  props: ['params', 'type'],
  data() {
    return {
      list: [],
      value: '',
      oktext: '确定',
      title: '给筛查对象打标签',
      titGroupd: '标签',
      adGroupd: false,
      total: 0,
      current: 1,
      size: 5,
      modal1: false,
      sizes: [5, 20, 30, 40],
      columns: [
        {
          title: '选择',
          slot: 'single',
          align: 'center',
        },
        {
          title: '填写人',
          slot: 'name',
          align: 'center',
        },
        {
          title: '性别',
          slot: 'gender',
          align: 'center',
        },
        {
          title: '年龄',
          slot: 'age',
          align: 'center',
        },
        {
          title: '手机号码',
          slot: 'phone',
          align: 'center',
        },
        {
          title: '填写时间',
          slot: 'create_time',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'action',
          width: 200,
          align: 'center',
        },
      ],
      isAll: false,
      loading: false,
      animal: [],
      tags: [],
      tag_ids: '',
      patientIds: [],
      disabled: true,
      single: false,
    }
  },
  computed: {},
  components: {},
  mounted() {
    this.getData()
    this.getTagList()
  },
  methods: {
    getData() {
      this.params.page = this.current
      this.params.size = this.size

      if (this.type == '0') {
        filtrate(this.params).then((res) => {
          if (res.code === 0) {
            if (res.data.list.length == 0) {
              this.disabled = true
            } else {
              if (this.animal.includes('all')) {
                res.data.list.forEach((v) => {
                  v.single = true
                })
                this.disabled = false
              } else {
                this.animal = []
                this.disabled = true
                res.data.list.forEach((v) => {
                  v.single = false
                })
              }
            }

            this.list = res.data.list
            this.total = Number(res['x-total-count'])
            this.$emit('AnalysiList', res.data)
          } else {
            this.$Message.warning(res.message)
          }
        })
      } else {
        confirmedFiltrate(this.params).then((res) => {
          if (res.code === 0) {
            if (res.data.length == 0) {
              this.disabled = true
            } else {
              if (this.animal.includes('all')) {
                res.data.list.forEach((v) => {
                  v.single = true
                })
                this.disabled = false
              } else {
                this.animal = []
                this.disabled = true
                res.data.list.forEach((v) => {
                  v.single = false
                })
              }
            }

            this.list = res.data.list
            this.total = Number(res['x-total-count'])
            this.$emit('AnalysiList', res.data)
          } else {
            this.$Message.warning(res.message)
          }
        })
      }
    },
    addAll() {
      this.modal1 = true
      this.tag_ids = []
    },

    del() {
      if (this.oktext == '保存') {
        this.adGroupd = false
        this.oktext = '确定'
        this.title = '给筛查对象打标签'
        this.titGroupd = '标签'
      } else {
        this.modal1 = false
      }
    },
    addGroupd() {
      this.value = ''
      this.oktext = '保存'
      this.titGroupd = '新增标签'
      this.title = '新增标签'
      this.adGroupd = true
    },
    agree() {
      if (this.oktext == '确定') {
        if (this.tag_ids.length == 0) {
          this.$Message.warning('请选择标签')
          return
        }
        if (this.animal.includes('all')) {
          // 所有页打标签
          this.tagTotal()
        } else {
          // 当前页打标签
          this.tagPage()
        }
      } else {
        if (!this.value) {
          this.$Message.warning('请新增标签')
          return
        }
        let obj = {
          type: this.type,
          name: this.value,
        }
        addTag(obj).then((res) => {
          if (res.code === 0) {
            this.$Message.success('新增成功')
            this.getTagList()
            this.adGroupd = false
            this.oktext = '确定'
            this.title = '给筛查对象打标签'
            this.titGroupd = '标签'
          }
        })
      }
    },
    // 当前页打标签
    tagPage() {
      let obj = {
        type: this.type,
        tag_ids: this.tag_ids,
      }
      if (this.type == '0') {
        obj.person_ids = this.patientIds
      } else {
        obj.patient_ids = this.patientIds
      }
      classfiyTagPage(obj).then((res) => {
        if (res.code === 0) {
          this.$Message.success(res.dev_message)
          this.modal1 = false
          this.patientIds = []
          this.getData()
        }
      })
    },
    // 所有页打标签
    tagTotal() {
      let obj = {
        type: this.type,
        filter_request: this.params,
        tag_ids: this.tag_ids,
      }
      classfiyTagTotal(obj).then((res) => {
        if (res.code === 0) {
          this.$Message.success(res.dev_message)
          this.modal1 = false
          this.patientIds = []
          this.animal = []
          this.getData()
        }
      })
    },
    cancel() {},
    changeSelection(row) {
      if (row.length == this.list.length) {
        if (this.animal.includes('all')) {
        } else {
          this.animal = ['current']
        }
      } else {
        if (this.animal.includes('current')) {
          this.animal = []
        } else if (this.animal.includes('all')) {
          const { rebuildData, objData } = this.$refs.selection
          for (const data of rebuildData) {
            objData[data._index]._isChecked = true
          }
        }
      }
    },
    unique(arr) {
      return Array.from(new Set(arr))
    },
    onCurrentChange(current) {
      this.current = current
      this.getData()
    },
    onSizeChange(size) {
      this.size = size
      this.getData()
    },
    patientDetail: function (i) {
      console.log(this.type)
      if (this.type == '0') {
        this.$store.commit('setAllSelectedKeys', {
          type: 'add',
          name: 'filterBasic',
          title: i.name + '—筛查信息',
          key: `filterBasic?${i.id}`,
          extra: {
            user: i,
          },
        })
      } else {
        this.$store.commit('setAllSelectedKeys', {
          type: 'add',
          name: 'medicalBasic',
          title: i.name + '—慢病信息',
          key: `medicalBasic?${i.id}`,
          extra: {
            user: i,
          },
        })
      }
    },
    handleSelectAll() {
      this.patientIds = []
      if (this.animal.length > 1) {
        this.animal.shift()
      }
      if (this.animal.length) {
        this.list = this.list.map((l) => {
          l.single = true
          this.patientIds.push(l.id)
          return l
        })
        this.disabled = false
      } else {
        this.list = this.list.map((l) => {
          l.single = false
          return l
        })
        this.disabled = true
      }
      // console.log(this.patientIds)
    },
    getTagList: function () {
      let type = this.type
      let page = this.current
      let size = this.size
      let need_page = 0
      getTag({ type, page, size, need_page }).then((res) => {
        // this.loading = false
        if (res.code === 0) {
          console.log(res)
          let tags = res.data
          this.tags = tags
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    changeBox(row, index) {
      row.single = !row.single
      if (row.single) {
        this.patientIds.push(row.id)
      } else {
        this.patientIds.forEach((l, j) => {
          if (l == row.id) {
            this.patientIds.splice(j, 1)
          }
        })
      }
      if (this.animal.includes('all')) {
        row.single = true
        return
      }
      this.list[index].single = row.single
      let list = this.list
      let sum = 0

      list.forEach((v) => {
        if (v.single) {
          sum++
        }
      })
      if (sum == list.length) {
        this.animal = ['current']
        this.disabled = false
      } else if (sum > 0) {
        this.animal = []
        this.disabled = false
      } else {
        this.animal = []
        this.disabled = true
      }
      // console.log(this.patientIds)
    },
  },
  watch: {
    params(val) {
      this.params = val
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../../styles/common.less';
.modalBox {
  height: 40px;
  .addspan {
    padding-left: 10px;
    padding-right: 10px;
    color: rgb(45, 140, 240);
    font-size: 15px;
    cursor: pointer;
  }
}
.report {
  padding: 20px;
  .report_t {
    i {
      width: 5px;
      height: 13px;
      background: #ffa615;
      border-radius: 5px;
      display: inline-block;
      margin-right: 6px;
    }
    &::after {
      content: '';
      display: block;
      clear: both;
    }
  }
  .report_content {
    .radio {
      margin: 20px 0;
      div {
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}

.allChoose {
  width: 100%;
  background: #f5f5f5;
  padding: 10px;
  .ivu-radio-wrapper {
    font-size: 15px;
  }
}
.ivu-checkbox-wrapper {
  font-size: 14px;
}
</style>
